import { useState, useEffect, useContext } from "react";
import { Card } from "antd";

import { Context } from "../../context";

import "./styles.css";

const Analytics = () => {
  const { apiUrl } = useContext(Context);
  const [src, setSrc] = useState("");
  useEffect(() => {
    if (apiUrl.includes("pbn-api.fastpix.com")) {
      setSrc(
        "https://plausible.io/share/pbnpresents.practicenumbers.com?auth=Q_Bkge0HR3hruwGdq8E2Y&embed=true&theme=light&background=transparent"
      );
    } else {
      setSrc(
        "https://plausible.io/share/pbn.fastpix.dev?auth=i4jSNA-R6lXh2_QmhmqOE&embed=true&theme=light&background=transparent"
      );
    }
  }, [apiUrl]);
  return (
    <div>
      <Card title="Website Analytics" className="reports-wrapper">
        <iframe
          title="Plausible Analytics"
          src={src}
          loading="lazy"
          style={{
            width: "1px",
            minWidth: "100%",
            height: "100vh",
            border: "none",
            overflow: "auto",
          }}
        />
        <script async src="https://plausible.io/js/embed.host.js"></script>
      </Card>
    </div>
  );
};

export default Analytics;
